// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ApiProperty(...args: unknown[]): PropertyDecorator {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return function () {};
}
